export const SOCIAL_VIDEO_FORMATS = ['vertical', 'horizontal'] as const;

export type ISocialVideoFormat = (typeof SOCIAL_VIDEO_FORMATS)[number];

export const DEFAULT_SOCIAL_VIDEO_FORMAT: ISocialVideoFormat = 'vertical';
